// extracted by mini-css-extract-plugin
export default {"wrapper":"page404_wrapper__qH9+K"};